export const RSN_DEFAULT_PACKAGES = [
  "ATT_TV_CHOICE",
  "ATT_TV_PREMIER",
  "ATT_TV_ULTIMATE"
];

export const LOCAL_DEFAULT_PACKAGES = [
  "ATT_TV_ENTERTAINMENT",
  "ATT_TV_CHOICE",
  "ATT_TV_PREMIER",
  "ATT_TV_ULTIMATE"
];

export const FALLBACK_CHNL_ICON_URL = 'https://www.directv.com/dtvassets/global/channel-icons/m-n/Channel_Icon_No-Logo.svg';

export const ctaForInternetInLocalRSNBackup = {
  localPkgShopCta: [
    {
      accessibility: "Shop MYSPORTS",
      label: "Shop MYSPORTS",
      targeturl: "/shop/mysports-package/",
      target: "_self"
    },
    {
      accessibility: "Shop ENTERTAINMENT",
      label: "Shop ENTERTAINMENT",
      targeturl: "/shop/entertainment-package/",
      target: "_self"
    },
    {
      accessibility: "Shop CHOICE™",
      label: "Shop CHOICE™",
      targeturl: "/shop/choice-package/",
      target: "_self"
    },
    {
      accessibility: "Shop ULTIMATE",
      label: "Shop ULTIMATE",
      targeturl: "/shop/ultimate-package/",
      target: "_self"
    },
    {
      accessibility: "Shop PREMIER",
      label: "Shop PREMIER",
      targeturl: "/shop/premier-package/",
      target: "_self"
    },
    {
      accessibility: "Shop ÓPTIMO MÁS™",
      label: "Shop ÓPTIMO MÁS™",
      targeturl: "/shop/optimo-mas-package/",
      target: "_self"
    }
  ],
  rsnPkgShopCta: [
    {
      accessibility: "Shop CHOICE™",
      label: "Shop CHOICE™",
      targeturl: "/shop/choice-package/",
      target: "_self"
    },
    {
      accessibility: "Shop ULTIMATE",
      label: "Shop ULTIMATE",
      targeturl: "/shop/ultimate-package/",
      target: "_self"
    },
    {
      accessibility: "Shop PREMIER",
      label: "Shop PREMIER",
      targeturl: "/shop/premier-package/",
      target: "_self"
    }
  ]
};

export const ctaForSatelliteLocalRSNBackup = {
  localPkgShopCta: [
    {
      accessibility: "Shop ENTERTAINMENT",
      label: "Shop ENTERTAINMENT",
      targeturl: "/shop/dtvs/entertainment-package/",
      target: "_self"
    },
    {
      accessibility: "Shop CHOICE™",
      label: "Shop CHOICE™",
      targeturl: "/shop/dtvs/choice-package/",
      target: "_self"
    },
    {
      accessibility: "Shop ULTIMATE",
      label: "Shop ULTIMATE",
      targeturl: "/shop/dtvs/ultimate-package/",
      target: "_self"
    },
    {
      accessibility: "Shop PREMIER",
      label: "Shop PREMIER",
      targeturl: "/shop/dtvs/premier-package/",
      target: "_self"
    },
    {
      accessibility: "Shop ÓPTIMO MÁS™",
      label: "Shop ÓPTIMO MÁS™",
      targeturl: "/shop/dtvs/optimo-mas-package/",
      target: "_self"
    }
  ],
  rsnPkgShopCta: [
    {
      accessibility: "Shop CHOICE™",
      label: "Shop CHOICE™",
      targeturl: "/shop/dtvs/choice-package/",
      target: "_self"
    },
    {
      accessibility: "Shop ULTIMATE",
      label: "Shop ULTIMATE",
      targeturl: "/shop/dtvs/ultimate-package/",
      target: "_self"
    },
    {
      accessibility: "Shop PREMIER",
      label: "Shop PREMIER",
      targeturl: "/shop/dtvs/premier-package/",
      target: "_self"
    }
  ]
};

export const mockLocalData = [
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "LOCAL",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  }
];

export const mockRsnData = [
  {
    category: "RSN",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "RSN",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "RSN",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  },
  {
    category: "RSN",
    icon: "/dtvassets/global/component-assets/guide/EmptySVG.svg",
    name: "Loading...",
    isStream: true,
    isSatellite: false,
    isMock: true
  }
];

export const defaultThemingDark = {
  page: {
    backgroundUrl: "https://www.directv.com/dtvassets/global/component-assets/in-page_clup/channel_background.jpg",
    backgroundColor: "#102641",
    theme: "onDark"
  },
  categoriesTab: {
    // all elements inherit page-level configuration, except MyFree banner
    myFreeDtvBanner: {
      background: "#EEF9FF",
      theme: "onLight"
    }
  },
  packagesTab: {
    header: {
      background: "transparent",
      theme: "onDark"
    },
    sort: {
      background: "transparent",
      theme: "onDark"
    },
    packageTiles: [
      {
        background: "#F0FBFF",
        theme: "onLight"
      }, {
        background: "#FFFAF6",
        theme: "onLight"
      }, {
        background: "#E9F1FB",
        theme: "onLight"
      }, {
        background: "#FEF2FE",
        theme: "onLight"
      }
    ],
    myFreeDtvBanner: {
      background: "#EEF9FF",
      theme: "onLight"
    },
    sectionHeaders: {
      background: "#FFF",
      theme: "onLight"
    },
    grid: {
      background: "transparent",
      theme: "onDark"
    },
    gridAddOnPromos: {
      background: "#21528c",
      theme: "onDark"
    }
  }
};

export const defaultThemingLight = {
  page: {
    backgroundUrl: "",
    backgroundColor: "neutral100", // fallback color
    theme: "onLight"
  },
  categoriesTab: {
    // all follow page theme except my free banner
    myFreeDtvBanner: {
      background: "#EEF9FF",
      theme: "onLight"
    }
  },
  packagesTab: {
    header: {
      background: "transparent",
      theme: "onLight"
    },
    sort: {
      background: "transparent",
      theme: "onLight"
    },
    packageTiles: [
      {
        background: "#ECF3FB",
        theme: "onLight"
      }, {
        background: "#D8E7F9",
        theme: "onLight"
      }, {
        background: "#7DB3F2",
        theme: "onLight"
      }, {
        background: "#196DD4",
        theme: "onLight"
      }
    ],
    myFreeDtvBanner: {
      background: "turquoise50",
      theme: "onLight"
    },
    grid: {
      background: "transparent",
      theme: "onLight"
    },
    sectionHeaders: {
      background: "#ECF3FB",
      theme: "onLight"
    }
  }
};

